module.exports = __webpack_public_path__ + "img/1.702583eb.png";